import type { ApiResponse, Detection } from '@packages/shared-types';

import { apiClient } from '@/services/apiClient';

export interface ListDetectionsPaginatedParams {
  page: number;
  limit: number;
  startDate?: Date;
  endDate?: Date;
}

export interface ListDetectionsPaginatedResult {
  data: Detection[];
  total: number;
  page: number;
  limit: number;
}

export async function listDetectionsPaginated(
  params: ListDetectionsPaginatedParams,
): Promise<ListDetectionsPaginatedResult> {
  const { page, limit, startDate, endDate } = params;
  const queryParams: Record<string, string | number> = { page, limit };
  if (startDate) {
    queryParams.startDate = startDate.toISOString();
  }
  if (endDate) {
    queryParams.endDate = endDate.toISOString();
  }
  const response = await apiClient.get<
    ApiResponse<ListDetectionsPaginatedResult>
  >('/api/detections', {
    params: queryParams,
  });
  const payload = response.data.data;
  return {
    data: payload.data,
    total: payload.total,
    page: payload.page,
    limit: payload.limit,
  };
}

export async function listDetections(filters?: {
  startDate?: Date;
  endDate?: Date;
}): Promise<Detection[]> {
  const params: Record<string, string> = {};
  if (filters?.startDate) {
    params.startDate = filters.startDate.toISOString();
  }
  if (filters?.endDate) {
    params.endDate = filters.endDate.toISOString();
  }
  const response = await apiClient.get<ApiResponse<Detection[]>>('/api/detections', {
    params,
  });
  return response.data.data;
}

export async function getDetectionById(id: string): Promise<Detection> {
  const response = await apiClient.get<ApiResponse<Detection>>(`/api/detections/${id}`);
  return response.data.data;
}

export async function getDetectionsByItemId(itemId: string): Promise<Detection[]> {
  const result = await getDetectionsByItemIdPaginated(itemId, 1, 20);
  return result.data;
}

export async function getDetectionsByItemIdPaginated(
  itemId: string,
  page: number,
  limit: number,
): Promise<ListDetectionsPaginatedResult> {
  const response = await apiClient.get<
    ApiResponse<ListDetectionsPaginatedResult>
  >(`/api/detections/item/${itemId}`, {
    params: { page, limit },
  });
  const payload = response.data.data;
  return {
    data: payload.data,
    total: payload.total,
    page: payload.page,
    limit: payload.limit,
  };
}
